
import { useState } from 'react'
import { useLogin } from "../../hooks/useLogin";

//STYLE
import Styles from './login.module.css'

//IMGS
import Logo from '../../assets/imgs/logo-rc.png'
import Back from '../../assets/imgs/back24-25.png'
import { useNavigate } from 'react-router-dom'

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const { login, isPending, error} = useLogin()

    const nav = useNavigate()

    const handleSubmit = (e) => {
        e.preventDefault()
        login(email, password)
        // nav('/bar')
    }

    return (
        <>
            <div className={Styles.container}>
                <div className={`shadowed ${Styles['login-card']}`}>
                    <img src={Logo} alt="rc logo" />
                    <hr/>
                    <form onSubmit={handleSubmit}>
                        <label>
                            <span>Email:</span>
                            <input 
                                type="text"
                                required
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                            />
                        </label>
                        <label>
                            <span>Mot de passe:</span>
                            <input 
                                type="password"
                                required
                                onChange={(e) => setPassword(e.target.value)}
                                value={password}
                            />
                        </label>
                        {!isPending && <button className={Styles.btn} type="submit">Se connecter</button>}
                        {isPending && <button className={Styles.btn} disabled>Login in...</button>}
                    </form>
                </div>
            </div>
            <div className={Styles.background} style={{backgroundImage: `url(${Back})`}}></div>
        </>
    )
}
